import { smoothScrollTo } from './scrollUtils.js'

window.addEventListener('DOMContentLoaded', () => {
  const scrollDownBtn = document.getElementById('scroll_down')

  if (scrollDownBtn) {
    scrollDownBtn.addEventListener('click', (e) => {
      e.preventDefault()
      const target = document.getElementsByClassName('event-detail__pattern_image_box')[0]
      const start = window.scrollY
      const targetPosition = target.getBoundingClientRect().bottom + start
  
      smoothScrollTo(targetPosition, start)
    })
  }
})
